import React, {useEffect, useState} from "react";
import axios from 'axios';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaPaperPlane } from "react-icons/fa";


import Breadscrumbs from './Breadscrumbs';

const ContactUsPage = () => {
    const [about, setAbout] = useState([])
    
    useEffect(() => {
        axios.get(`${process.env.REACT_APP_STRAPI_API_URL}/about?populate=*`, {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRAPI_TOKEN}`,
          }
        }).then(res => {
          setAbout(res.data.data);
        }).catch(err => console.error(err));
    }, [])


  return (
      <div>
      <Breadscrumbs title="Liên hệ" />

      <section className="max-w-6xl mx-auto px-4 md:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          <div className="bg-white p-6 rounded-xl shadow-md flex items-center space-x-4">
            <div className="text-green-500 text-2xl">
              <FaPhoneAlt />
            </div>
            <div>
              <h4 className="font-semibold mb-1">Số điện thoại</h4>
              <a href="tel:{about.phone_number}" className="hover:text-yellow-400">{about.phone_number}</a>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md flex items-center space-x-4">
            <div className="text-red-500 text-2xl">
              <FaEnvelope />
            </div>
            <div>
              <h4 className="font-semibold mb-1">Địa chỉ email</h4>
              <a href="mailto:{about.email}" className="hover:text-yellow-400">{about.email}</a>
            </div>
          </div>

          <div className="bg-white p-6 rounded-xl shadow-md flex items-center space-x-4">
            <div className="text-blue-500 text-2xl">
              <FaMapMarkerAlt />
            </div>
            <div>
              <h4 className="font-semibold mb-1">Địa điểm văn phòng</h4>
              <p>{about.address}</p>
            </div>
          </div>
        </div>

        {/* About Section 
        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <iframe
              src="https://www.google.com/maps?q=Số+1D+ngõ+165+Giáp+Bát,+P.+Giáp+Bát,+Q.+Hoàng+Mai,+Hà+Nội&output=embed"
              width="100%"
              height="350"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Google Map"
            ></iframe>
          </div>

          <div>
            <h3 className="text-xl font-semibold mb-4">Gửi Liên Hệ Với Chúng Tôi</h3>
            <form className="space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Họ và tên"
                  className="border p-3 rounded w-full"
                />
                <input
                  type="email"
                  placeholder="Email"
                  className="border p-3 rounded w-full"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="text"
                  placeholder="Số điện thoại"
                  className="border p-3 rounded w-full"
                />
                <input
                  type="text"
                  placeholder="Địa chỉ"
                  className="border p-3 rounded w-full"
                />
              </div>
              <textarea
                placeholder="Nội dung"
                className="border p-3 rounded w-full h-32"
              ></textarea>

              <button
                type="submit"
                className="bg-yellow-500 hover:bg-yellow-600 text-white px-6 py-3 rounded-xl flex items-center justify-center space-x-2"
              >
                <FaPaperPlane /> <span>Gửi đi</span>
              </button>
            </form>
          </div>
        </div>
        */}

      </section>
    </div>
  );
};

export default ContactUsPage;
